import React, {useEffect, useState} from 'react';
import {Link, useSearchParams} from "react-router-dom";
import WrapperContent from "../../components/shared/WrapperContent";
import HeaderContent from "../../components/shared/HeaderContent";
import style from "../drivers/index.module.scss";
import PlusIcon from "../../components/shared/icons/PlusIcon";
import ArrowDownIcon from "../../components/shared/icons/ArrowDownIcon";
import CarsItemCard from "../../components/cars/CarsItemCard";
import ModalConfirm from "../../components/shared/ModalWindow/Confirm";
import {Driver} from '../../services';
import {useSelector} from 'react-redux';
import {requestErrorDisplay} from '../../utils';
import Loading from '../../components/shared/Loading/Loading';
import EmptyContent from '../../components/shared/emptyContent';
import { t } from "i18next";

const CarsPage = () => {
  const { user } = useSelector(state => state);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setLoading] = useState(false)
  const [vehicles, setVehicles] = useState([])

  const getContent = () => {
    setLoading(true)
    if (!user?.companyId) {
      return
    }
    Driver.getVehicleByExpeditor(user.companyId)
      .then(res => res.data)
      .then(data => {
        setVehicles(data || [])
      })
      .catch(e => {
        requestErrorDisplay(e)
      })
      .finally(() => {
        setLoading(false)
      })
  }
  useEffect(() => {
    getContent()
  }, [])
  return (
    <div className={style.workers_wrapper}>
      <WrapperContent>
        <HeaderContent title={t("cars.pageTitle")} />
        <Link to={"/cars/create"} className={style.button}>
          <PlusIcon/>
          <span>{t("cars.addCarButton")}</span>
        </Link>
        <div className={style.itemsSort}>
          <span>{t("cars.countLabel", { count: vehicles.length })}</span>
          {/* TODO */}
          {/*<div className={style.dropdown}>*/}
          {/*  <div className={style.dropdown_selected}>*/}
          {/*    <span>По алфавиту</span>*/}
          {/*    <ArrowDownIcon />*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
        <CarsItemCard isHead />
        { isLoading && <Loading inBlock /> }
        { vehicles.map(v => <CarsItemCard key={v.id} item={v} onVehicleUpdate={getContent} />)}
        { !isLoading && !vehicles.length && <EmptyContent /> }
        { searchParams.get("created") === "1" && (
          <ModalConfirm
            onClose={() => setSearchParams({ created: 0 })}
            title={t("cars.modal.carAddedTitle")}
            summary={t("cars.modal.carAddedSummary")}
          />
        )}
      </WrapperContent>
    </div>
  );
};

export default CarsPage;